export default {
  meta: {
    title: '预估客流'
  }
};
